import axios from 'axios'
import { toast } from 'react-toastify'
import config from '../config/environment'

const api = axios.create({
  baseURL: config.ADMIN_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      window.location.href = '/admin/login'
    }
    return Promise.reject(error)
  }
)

export const currencyService = {
  /**
   * @returns {Promise<{ success: boolean, data?: { currencies: Array }, message?: string }>}
   */
  async listCurrencies() {
    try {
      const response = await api.get('/currencies')
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to load currencies'
      toast.error(errorMessage)
      throw new Error(errorMessage)
    }
  },
}

export default currencyService
